import { rail } from '@/theme/colors'
import styled, { css } from 'styled-components'

/**
 * Timeline dash colour shared by the itinerary board's rail and the trip
 * overview's itinerary preview rail (dots, lines, chips).
 */
export const TIMELINE_DASH = rail

/** How far a connector overshoots the next anchor so its clipped final dash
 * lands under the opaque dot/chip instead of showing as a fragment. */
const ANCHOR_OVERHANG = 4

const dashes = css`
	width: 2px;
	background-image: repeating-linear-gradient(
		to bottom,
		${TIMELINE_DASH} 0 3px,
		transparent 3px 7px
	);
`

/**
 * One dashed connector spanning a single timeline gap, from this row's anchor
 * (`$from` px below its top) to just past the next row's (`$into`).
 *
 * Absolutely positioned inside the 24px rail column so each gap is ONE dash
 * run: the rhythm never restarts mid-gap and the only clipped dash hides under
 * the following dot/chip (which must be `position: relative` to paint on top).
 * Dashed borders collapse short pieces into solid chunks; stitched gradients
 * clip a fragment at every seam.
 */
export const RailConnector = styled.span<{ $from: number; $into: number }>`
	position: absolute;
	left: 11px; /* centre of the 24px rail, minus half the 2px line */
	top: ${({ $from }) => $from}px;
	bottom: ${({ $into }) => -($into + ANCHOR_OVERHANG)}px;
	${dashes}
`
